export function getCredibilityData({ vehicleName, hasLongTerm, hasEditorialRating }) {
  const defaultDroveItText = `Our Edmunds experts put the ${vehicleName} through rigorous testing on the road and track to help you make informed decisions in your next car purchase.`;

  switch (true) {
    case hasLongTerm: {
      return {
        dataPoint: '20,000+',
        text: 'mile road test',
        droveItText: `The ${vehicleName} is part of our one-year road test. Our Edmunds experts drive this car every day to help you make informed decisions about your next car purchase.`,
      };
    }
    case hasEditorialRating: {
      return { dataPoint: '127+', text: 'details tested', droveItText: defaultDroveItText };
    }
    default: {
      return { dataPoint: '300+', text: 'cars driven each year', droveItText: defaultDroveItText };
    }
  }
}

export function getLayoutProps({ hasEditorialRating, hasTypeRanking, isFloatVerdict, isMobile }) {
  let verdictMdCol;
  if (hasEditorialRating) {
    verdictMdCol = hasTypeRanking ? 7 : 9;
  }

  const verdictMaxLength = !isMobile && hasEditorialRating && !hasTypeRanking ? 400 : 250;

  let ratingMdCol;
  if (!isFloatVerdict) {
    ratingMdCol = hasTypeRanking ? 5 : 3;
  }

  return { verdictMdCol, verdictMaxLength, ratingMdCol };
}
